import axios from "axios";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? ""
    : process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

export const TOKEN_STORAGE_KEY = "futryard_access_token";
export const USER_STORAGE_KEY = "futryard_user";
// export const verifyProperty = (id) =>
//   api.patch(`/admin/properties/${id}/verify`, { is_verified: true }).then(r => r.data);
export const api = axios.create({
  baseURL: API_BASE_URL
});

export const verifyProperty = (id, isVerified) =>
  api.patch(`/admin/properties/${id}/verify`, { is_verified: isVerified })
     .then(r => r.data);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setAuthSession(accessToken, user) {
  localStorage.setItem(TOKEN_STORAGE_KEY, accessToken);
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
}

export function clearAuthSession() {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);
}

export function getStoredUser() {
  const raw = localStorage.getItem(USER_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export const signup = async (payload) => {
  const response = await api.post("/auth/signup", payload);
  return response.data;
};

export const login = async (payload) => {
  const response = await api.post("/auth/login", payload);
  return response.data;
};

export const getMe = async () => {
  const response = await api.get("/auth/me");
  return response.data;
};

export const getProperties = async (filtersOrStatus) => {
  const params =
    typeof filtersOrStatus === "string"
      ? { status: filtersOrStatus }
      : filtersOrStatus || undefined;

  const response = await api.get("/properties", { params });
  return response.data;
};

export const searchProperties = async (params) => {
  const response = await api.get("/properties", { params });
  return response.data;
};

export const getPropertyById = async (id) => {
  const response = await api.get(`/properties/${id}`);
  return response.data;
};

export const addProperty = async (payload) => {
  const response = await api.post("/properties", payload);
  return response.data;
};

export const updateProperty = async (id, payload) => {
  const response = await api.put(`/properties/${id}`, payload);
  return response.data;
};

export const deleteProperty = async (id) => {
  await api.delete(`/properties/${id}`);
};

export const submitInquiry = async (propertyId, message) => {
  const response = await api.post(`/properties/${propertyId}/inquiries`, {
    message
  });
  return response.data;
};

export const submitPublicInquiry = async (payload) => {
  const response = await api.post("/public/inquiries", payload);
  return response.data;
};

export const createPublicListing = async (payload) => {
  const response = await api.post("/public/listings", payload);
  return response.data;
};

export const getPendingProperties = async () => {
  const response = await api.get("/admin/properties/pending");
  return response.data;
};

export const getAdminPublicInquiries = async () => {
  const response = await api.get("/admin/public-inquiries");
  return response.data;
};

export const sharePublicInquiryWithPublisher = async (id) => {
  const response = await api.patch(`/admin/public-inquiries/${id}/share`);
  return response.data;
};

export const approveProperty = async (id) => {
  const response = await api.patch(`/admin/properties/${id}/approve`);
  return response.data;
};

export const rejectProperty = async (id) => {
  const response = await api.patch(`/admin/properties/${id}/reject`);
  return response.data;
};

export const adminEditProperty = async (id, payload) => {
  const response = await api.put(`/admin/properties/${id}`, payload);
  return response.data;
};

export const adminDeleteProperty = async (id) => {
  await api.delete(`/admin/properties/${id}`);
};
